// @ts-nocheck
/* eslint-disable */
export const exploreIcon = {
    data: `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 15C11.864 15 15 11.864 15 8C15 4.129 11.864 1 8 1C4.129 1 1 4.129 1 8C1 11.864 4.129 15 8 15ZM8.315 6.166C9.001 6.439 9.554 6.978 9.848 7.664L11.143 10.688C11.262 10.975 10.968 11.269 10.681 11.143L7.65 9.841C6.964 9.547 6.425 8.994 6.145 8.301L5.018 5.48C4.899 5.193 5.186 4.906 5.466 5.025L8.28 6.145L8.315 6.166Z" fill="currentColor"/></svg>`,
    name: 'explore' as const
};